export const CHECKBOX_STATES = {
    Checked: 'Checked',
    Indeterminate: 'Indeterminate',
    Unchecked: 'Unchecked'
};

export const FIELD_TSIZE = {
    Small: 'sm',
    Medium: 'md',
    Large: 'lg'
}

export const FORM_FIELDS = {
    AdultPreferences: 'adultPreferences',
    PediatricPreferences: 'pediatricPreferences',
    Genders: 'genders',
    Races: 'races',
    Ethnicities: 'ethnicities',
    ResearchAreaFilter: 'researchAreaFilter',
    Age: 'age',
    Compensation: 'compensation',
    HealthyVolunteer: 'healthyVolunteer',
    InPersonVisit: 'inPersonVisit',
    Participation: 'participation',
    Ordering: 'ordering',
    PageSize: 'pageSize',
    PageNumber: 'pageNumber',
    SearchTerm: 'searchTerm',
    IncludeFilters: 'includeFilters',
    StudyStatusStates: 'studyStatusStates'
};

export const FORM_FIELD_LABELS = {
    [FORM_FIELDS.Genders]: 'Sex', /* BMP RF-1816 */
    [FORM_FIELDS.Races]: 'Race',
    [FORM_FIELDS.Ethnicities]: 'Ethnicity',
    [FORM_FIELDS.Age]: 'Age',
    [FORM_FIELDS.Compensation]: 'Compensation',
    [FORM_FIELDS.HealthyVolunteer]: 'Healthy Volunteer',
    [FORM_FIELDS.InPersonVisit]: 'In-Person Visit',
    [FORM_FIELDS.Participation]: 'Studies I Have Participated In',
    [FORM_FIELDS.Ordering]: 'Sort By'
}

export const FORM_ACTIONS = {
    ParentCheck: 'parentCheck',
    ChildCheck: 'childCheck',
    TextInput: 'TextInput',
    Selection: 'selection',
    Clear: 'clear',
};

export const DISMISS_STATES = {
    Present: 'present',
    Dismissing: 'dismissing',
    Dismissed: 'dismissed',
    UndoDismiss: 'undoDismiss'
};

export const RECAPTCHA_ACTIONS = {
    Join: 'join'
}
